import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import { Logo, SearchIcon, BarsIcon, LoaderIcon, user1Icon } from '../Constant/Index';
import AOS from 'aos';
const Header = () => {
    const [mobileNav, SetmobileNav] = useState(false);
    const [loading, setLoading] = useState(true);
    const [searchBar, SetSearchBar] = useState(false);
    useEffect(() => {
        // Simulate an API call or any asynchronous operation
        setTimeout(() => {
            setLoading(false);
        }, 100);
    }, []);
    function toggleNav() {
        SetmobileNav(prevState => !prevState);
    }
    const toggleSearch = () => {
        SetSearchBar(prevState => !prevState);
    }
    React.useEffect(() => {
        AOS.init(); // Initialize AOS in your component
    }, []);


    const [userLogin, setUserLogin] = useState(false);
    const [therapistLogin, setTherapistLogin] = useState(false);
    const [haveUser, setHaveUser] = useState(false);

    useEffect(() => {
        // Your URL checking logic goes here
        const currentURL = window.location.href;

        if (currentURL.includes('user/')) {
            setUserLogin(true);
            setHaveUser(true);
        }
        if (currentURL.includes('therapist/')) {
            setTherapistLogin(true);
            setHaveUser(true);
        }

    }, []);



    return (
        <>
            {loading ? (
                <>
                    <div className="preloader" >
                        <img src={LoaderIcon} alt="" />
                    </div>
                </>
            ) : (
                <>

                    <header className={`header ${(mobileNav == true) ? " active" : " "}`}>
                        <div className="container">
                            <div className="header-start">
                                <figure className="logo-header">
                                    <Link to="/">
                                        <img src={Logo} alt="" className="logo" />
                                    </Link>
                                </figure>
                                <div className="menu-items">
                                    <ul className="menu-list">

                                        <li className="list-item">
                                            <Link className='single-item' to="/">Home</Link>

                                        </li>
                                        <li className="list-item">
                                            <Link className='single-item' to="/aboutus">About Us</Link>
                                        </li>
                                        <li className="list-item">
                                            <Link className='single-item' to="/services">Services</Link>
                                        </li>
                                        <li className="list-item">
                                            <Link className='single-item' to="/contactus">Contact us</Link>
                                        </li>
                                    </ul>
                                    <div className={`nav-others ${(userLogin || therapistLogin) ? 'active' : ''} `}>
                                        <ul>
                                            <li className='d-none d-lg-flex'>
                                                <button className='search-btn' onClick={toggleSearch}><img src={SearchIcon} className='search-icon' alt="" /></button>
                                            </li>
                                            {!haveUser &&
                                                <li>
                                                    <Link className='btn' to="/signup">Create User</Link>
                                                </li>
                                            }
                                            {userLogin &&
                                                <li className='list-item-here'>
                                                    <Link className=' text-decoration-none ' to="/user/home">
                                                        <div className="d-flex align-items-center gap-2">

                                                            <div className="text-here d-flex flex-column">
                                                                <span className='profile-option'>My Profile</span>
                                                                <span className="username">John Samual</span>
                                                            </div>
                                                            <figure className='user-icon'>
                                                                <img src={user1Icon} className='img-here' alt="" />
                                                            </figure>
                                                        </div>

                                                    </Link>

                                                </li>
                                            }
                                            {therapistLogin &&
                                                <li className='list-item-here'>
                                                    <Link className=' text-decoration-none ' to="/therapist/home">
                                                        <div className="d-flex align-items-center gap-2">

                                                            <div className="text-here d-flex flex-column">
                                                                <span className='profile-option'>Therapist Profile</span>
                                                                <span className="username">John Samual</span>
                                                            </div>
                                                            <figure className='user-icon'>
                                                                <img src={user1Icon} className='img-here' alt="" />
                                                            </figure>
                                                        </div>

                                                    </Link>

                                                </li>
                                            }
                                        </ul>
                                    </div>
                                    <button className="close-icon bg-transparent position-absolute top-0 right-0 d-block d-lg-none p-0 border-0 mt-3" onClick={toggleNav}>
                                        <svg width="30px" height="30px" viewBox="0 0 1024 1024" fill="#000000" class="icon" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M176.662 817.173c-8.19 8.471-7.96 21.977 0.51 30.165 8.472 8.19 21.978 7.96 30.166-0.51l618.667-640c8.189-8.472 7.96-21.978-0.511-30.166-8.471-8.19-21.977-7.96-30.166 0.51l-618.666 640z" fill="" /><path d="M795.328 846.827c8.19 8.471 21.695 8.7 30.166 0.511 8.471-8.188 8.7-21.694 0.511-30.165l-618.667-640c-8.188-8.471-21.694-8.7-30.165-0.511-8.471 8.188-8.7 21.694-0.511 30.165l618.666 640z" fill="" /></svg>
                                    </button>
                                </div>
                                <button className="open-nav-btn ms-auto me-2" onClick={toggleSearch}>
                                    <img src={SearchIcon} className='search-icon' alt="" />
                                </button>
                                <button className="open-nav-btn" onClick={toggleNav}>
                                    <img src={BarsIcon} alt="" />
                                </button>
                            </div>
                        </div>
                    </header>
                    <div class={`search-box ${(searchBar) ? 'show' : ''}`} >
                        <div class="container">
                            <button class="cancel" onClick={toggleSearch}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                                </svg>
                            </button>
                            <form >
                                <div class="form-group">
                                    <input type="text" name="search" class="form-control" placeholder="Search Here..." />
                                    <button type="submit"><i class="fa fa-search" aria-hidden="true"></i></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}
export default Header